import { useState } from 'react';

function EditMenu(props) {
    const {estimagasDispatch, estimagasState, setHideEdit, propData} = props;
    // { setHideEdit, propData, token, admin, setLoadTable, allData, ManagerStore }

    const [ano, setAno] = useState(propData.ano);
    const [total, setTotal] = useState(propData.quantidade);

    const formatAno = (value) => {
        // Remove qualquer caractere não-numérico
        const cleaned = value.replace(/\D/g, '');
        // Limita a 4 dígitos
        return cleaned.slice(0, 4);
    };

    const formatTotal = (value) => {
        // Remove qualquer caractere não-numérico, exceto vírgula
        const cleaned = value.replace(/[^\d,]/g, '');
        // Substitui vírgula por ponto para cálculos internos
        return cleaned.replace(',', '.');
    };

    const handleAnoChange = (e) => {
        const formattedValue = formatAno(e.target.value);
        setAno(formattedValue);
    };

    const handleTotalChange = (e) => {
        const formattedValue = formatTotal(e.target.value);
        setTotal(formattedValue);
    };

    const upRes = () => {
        let editData = { 'ano': ano, 'quantidade': total }
        let resData = estimagasState.resData;
        let edit = true;

        for (let i = 0; i < resData.length; i++) {
            if (resData[i].ano === ano) {
                edit = false;
            }
        }
        if (edit && ano > 0 && total > 0) {
            for (let i = 0; i < resData.length; i++)
                if (propData.ano === resData[i].ano) {
                    resData[i] = editData;
                }
            estimagasDispatch({type: 'RES_DATA', payload: resData});
        }
            setHideEdit(true);
    }



    return (
                    <div className={'pt-3 flex flex-row self-end justify-center items-center w-full'}>
                    <div className="flex flex-row border border-amber-800 p-5">
                    <div className='flex flex-col'>
                        <p className='inline-block box-content text-base -mb-1 text-stone-800 text-left font-semibold z-[1] ml-3 cursor-pointer'>
                            Ano
                        </p>
                        <input className='ml-1 mr-1 p-3 bg-stone-100 text-stone-700 border-2 rounded-2xl rounded-tl-none rounded-br-none text-[0.80rem] focus:bg-stone-100 focus:text-stone-700 hover:bg-stone-100 hover:text-stone-700'
                            type="text" placeholder="Ano" value={ano} 
                            onChange={handleAnoChange}
                        />
                    </div>
                    <div className='flex flex-col'>
                        <p title={"Quantidade em toneladas"} className='inline-block box-content text-base -mb-1 text-stone-800 text-left font-semibold z-[1] ml-3 cursor-pointer'>
                            Quantidade
                        </p>
                        <input className='ml-1 mr-1 p-3 bg-stone-100 text-stone-700 border-2 rounded-2xl rounded-tl-none rounded-br-none text-[0.80rem] focus:bg-stone-100 focus:text-stone-700 hover:bg-stone-100 hover:text-stone-700'
                            type="text" placeholder="Quantidade" value={total} 
                            onChange={handleTotalChange}
                            />
                    </div>
                    <button className='m-[none] p-2 cursor-pointer text-base text-stone-100 bg-emerald-700 rounded-tr h-10 min-w-[4.38rem] hover:bg-emerald-500 self-end font-bold'
                    onClick={() => upRes()}>Editar dado</button>
                    </div>
                </div>
    )
}

export default EditMenu;